export default __webpack_public_path__ + "images/d7464f9cb5c881df329d7f71934e45de-kareem-purple-icon.svg";